export default "__VITE_ASSET__486e5523__"